/**
 * Action Catalog read API — /shay/email/workflow-config/catalog/*.
 * Ref: 06_Frontend_API_Changes_Action_Catalog_2026-07-20.md §2, §7.
 *
 * Same session-JWT auth pattern as workflowConfigService.ts — the backend derives
 * company_id from the token. Read-only: there is no create/disable endpoint for
 * connections yet (§2, §7.5) — do not build UI against a guessed one.
 */
import { API_CONFIG, WORKFLOW_CATALOG_API_ENDPOINTS, STORAGE_KEYS } from '../helpers/constants';
import type {
  CatalogActionsByCategory,
  CatalogConnection,
} from '../components/ChannelSettings/WorkflowCanvas/workflowGraphTypes';
import { parseErrorDetail } from './apiErrorUtils';

function getSessionToken(): string {
  return (
    localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN) ||
    localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) ||
    ''
  );
}

function authHeaders(): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    accept: 'application/json',
    Authorization: `Bearer ${getSessionToken()}`,
  };
}

/** GET /catalog/actions — palette data, grouped by category. Never render `definition.template`. */
export async function getCatalogActions(): Promise<CatalogActionsByCategory> {
  const response = await fetch(
    `${API_CONFIG.ML_API_BASE_URL}${WORKFLOW_CATALOG_API_ENDPOINTS.ACTIONS}`,
    { method: 'GET', headers: authHeaders() }
  );
  if (!response.ok) throw new Error(await parseErrorDetail(response));
  return response.json();
}

/** GET /catalog/connections — never carries credentials. No admin write endpoint exists yet. */
export async function getCatalogConnections(): Promise<CatalogConnection[]> {
  const response = await fetch(
    `${API_CONFIG.ML_API_BASE_URL}${WORKFLOW_CATALOG_API_ENDPOINTS.CONNECTIONS}`,
    { method: 'GET', headers: authHeaders() }
  );
  if (!response.ok) throw new Error(await parseErrorDetail(response));
  return response.json();
}
